import './slick.min.js';
import './jquery.plugin.min.js';
import './jquery.countdown.min.js';
import './blocks/giveaway/index';
import './blocks/countdown/index';
import './blocks/winners/index';
